// O texto do aviso de manutenção, para a prévia da tela. Espelho de
// custom/app/services/neuxs/aviso_de_manutencao.rb (monta): mudou lá, muda aqui.

export const primeiroNome = nome => {
  const texto = String(nome ?? '').trim();
  if (!texto || /^[+\d\s().-]+$/.test(texto)) return '';
  const primeiro = texto.split(/\s+/)[0].toLocaleLowerCase('pt-BR');
  return primeiro.charAt(0).toLocaleUpperCase('pt-BR') + primeiro.slice(1);
};

export const montaAviso = (texto, nome) =>
  String(texto ?? '')
    .replace(/\{nome\}/gi, primeiroNome(nome))
    .replace(/[ \t]+([,.!?;:])/g, '$1')
    .replace(/[,;:](?=[.!?])/g, '')
    .replace(/[ \t]{2,}/g, ' ')
    .replace(/^[ \t]+|[ \t]+$/gm, '')
    .trim();
